"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Form = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _box = _interopRequireDefault(require("@waglabs/box"));

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Form = function Form(_ref) {
  var children = _ref.children,
      containerProps = _ref.containerProps,
      errors = _ref.errors,
      initialValues = _ref.initialValues,
      isInitialValid = _ref.isInitialValid,
      onSubmit = _ref.onSubmit,
      _render = _ref.render,
      validationSchema = _ref.validationSchema,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "containerProps", "errors", "initialValues", "isInitialValid", "onSubmit", "render", "validationSchema"]);

  var formRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (formRef && formRef.current && errors) {
      formRef.current.setErrors(errors);
    }
  }, [errors]);
  return _react.default.createElement(_formik.Formik, {
    ref: formRef,
    initialValues: initialValues,
    isInitialValid: isInitialValid,
    onSubmit: onSubmit,
    validationSchema: validationSchema,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
          form = _objectWithoutPropertiesLoose(_ref2, ["handleSubmit"]);

      return _react.default.createElement(_.StyledForm, _extends({
        onSubmit: handleSubmit,
        width: "100%"
      }, props), _react.default.createElement(_box.default, _extends({
        m: "0 auto"
      }, containerProps), _render(form)));
    }
  });
};

exports.Form = Form;
var _default = Form;
exports.default = _default;